;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.PopupMessage = Marionette.LayoutView.extend({
		template: JST.PopupMessage,
		regions: {
			modal_content: '.popup-content'
		},
		ui: {
			popup: '.popup-container',
			close_popup: '.js-popup-close',
			overlay:      '.popup-overlay'
		},

		events: {
			'click @ui.close_popup': 'closePopup',
			'click @ui.overlay': 'closePopup'
		},

		initialize: function() {
			this.listenTo(APP.vent, 'popup:message:show', this.showPopup);
			this.listenTo(APP.vent, 'popup:message:close_action', this.closePopupTrigger);
			this.appended_element = false;
			this.default_options = {
				prevent_close: false,
				custom_template: false
			};
			this.modal_option = {};
			this.popup_options = _.extend(this.default_options);
		},

		showPopup: function(data, title, popup_options) {

			if(popup_options){
				this.popup_options = _.extend(popup_options);
			}

			var $popup_block = this.$el.find('.popup-block'),
				top          = $popup_block.css('top');

			this.show_popup = false;

			//IE8 hack
			if(document.documentMode <= 9) {
				$popup_block.find('.popup-block').css({
					left: 25 + '%',
					top:  25 + '%'
				});
			}

			this.openPopup(data, title);
			return this;
		},

		openPopup: function(data, title) {
			this.show_popup = true;

			if(this.popup_options.custom_template){
				this.appended_element = data;
			}
			else {

				if (title) {
					this.appended_element = '<div class="step-subtitle"><h3>' + title + '</h3><p>' + data + '</p></div>';
				}
				else {
					this.appended_element = '<div class="step-subtitle"><h3>' + data + '</h3></div>';
				}

			}

			this.$el.find('.popup-content').html(this.appended_element);

			this.$el.find('.popup-container').removeClass('hidden');

			APP.vent.trigger('popup:message:ready');

			return this;
		},

		closePopup: function(e) {
			console.log(e.currentTarget.className === 'popup-overlay', this.modal_option);
			if (e.currentTarget.className === 'popup-overlay' && this.modal_option.notHideOnClick) {
				return false;
			}
			this.popup_options = _.extend(this.default_options);
			this.appended_element = false;
			this.show_popup = false;
			this.$el.find('.popup-container').addClass('hidden');
			this.$el.find('.popup-content').html('');
			APP.vent.trigger('popup:message:closed');

			return this;
		},

		closePopupTrigger: function(){
			this.popup_options = _.extend(this.default_options);
			this.appended_element = false;
			this.show_popup = false;
			this.$el.find('.popup-container').addClass('hidden');
			this.$el.find('.popup-content').html('');
			APP.vent.trigger('popup:message:closed');
		},

		popupStatus: function() {
			return this.show_popup;
		},

		showModalWithView({view, options = {}, view_options = {}}){
			_.extend(this.options, options);
			_.extend(this.modal_option, view_options);
			this.modal_content.show(view);

			this.setUpModalOptions()
				.loadPopup();
		},
		setUpModalOptions() {

			// this.$el.addClass(this.modal_option.className)
			// 	.css(this.modal_option.style);

			this.ui.close_popup.toggleClass('hidden', !this.modal_option.closeBtn);

			return this;
		},

		loadPopup() {
			APP.vent.trigger('popup:message:ready');
			var $popup_block = this.$el.find('.popup-block'),
				top          = $popup_block.css('top');

			this.show_popup = false;

			//IE8 hack
			if(document.documentMode <= 9) {
				$popup_block.find('.popup-block').css({
					left: 25 + '%',
					top:  25 + '%'
				});
			}
			this.$el.parent().addClass('show-popup');
			this.$el.find('.popup-container').removeClass('hidden');

			return this;
		},
	});

}(window, APP, Backbone, Marionette, $, _));